export const genRandomKey = () => Math.random();